// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"207":"e200eb62","621":"f8da797f","992":"9246273b"}[chunkId] + ".chunk.css";
};